import { render, staticRenderFns } from "./invoice-4.vue?vue&type=template&id=4c9d6c7e&"
import script from "./invoice-4.vue?vue&type=script&lang=js&"
export * from "./invoice-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports